import React, { useState } from "react"
import { MessageSquare, Mail } from "lucide-react"
import AddCreditsModal from "./messagecenter/_addcreditsmodal"
import { useGetCommunicationCreditsQuery } from "../../lib/apiSlice/communication/communicationSlice.tsx"

export default function CreditsSummary() {
  const [isTopUpOpen, setIsTopUpOpen] = useState(false)
  const [isWhatsappModal, setWhatsupModal] = useState(false)
  const { data: MessageCredits, isLoading, error } = useGetCommunicationCreditsQuery()

  return (
    <div className="gap-4 grid grid-cols-1 md:grid-cols-3">
      <div className="bg-white shadow-sm border border-gray-200 rounded-lg overflow-hidden">
        <div className="p-4 border-gray-200 border-b">
          <h3 className="flex items-center font-medium text-lg">
            <MessageSquare className="mr-2 w-5 h-5 text-blue-500" />
            SMS Credits
          </h3>
        </div>
        <div className="p-4">
          <div className="font-bold text-blue-500 text-3xl">{MessageCredits?.remaining_sms?.toLocaleString('en-US')}</div>
        </div>
        <div className="px-4 pb-4">
          <button
            className="hover:bg-gray-50 px-4 py-2 border border-gray-300 rounded-md w-full text-gray-700 text-sm"
            onClick={() => {
              setIsTopUpOpen(true)
            }}
          >
            Top Up
          </button>
        </div>
      </div>

      <div className="bg-white shadow-sm border border-gray-200 rounded-lg overflow-hidden">
        <div className="p-4 border-gray-200 border-b">
          <h3 className="flex items-center font-medium text-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="mr-2 w-5 h-5 text-green-500"
            >
              <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" />
              <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1Z" />
              <path d="M14 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1Z" />
              <path d="M9.5 13.5c.5 1 1.5 1 2.5 1s2-.5 2.5-1" />
            </svg>
            WhatsApp Credits
          </h3>
        </div>
        <div className="p-4">
          <div className="font-bold text-green-500 text-3xl">Whatsapp not configured</div>
        </div>
        <div className="px-4 pb-4">
          <button
            className="hover:bg-gray-50 px-4 py-2 border border-gray-300 rounded-md w-full text-gray-700 text-sm"
            onClick={() => {
              setWhatsupModal(true)
            }}
          >
            Set Up
          </button>
        </div>
      </div>

      <div className="bg-white shadow-sm border border-gray-200 rounded-lg overflow-hidden">
        <div className="p-4 border-gray-200 border-b">
          <h3 className="flex items-center font-medium text-lg">
            <Mail className="mr-2 w-5 h-5 text-purple-500" />
            Email Credits
          </h3>
        </div>
        <div className="p-4">
          <div className="font-bold text-purple-500 text-3xl">∞</div>

        </div>
        <div className="px-4 pb-4">
          <button
            className="hover:bg-gray-50 px-4 py-2 border border-gray-300 rounded-md w-full text-gray-700 text-sm"

          >
            All Set
          </button>
        </div>
      </div>

      {isTopUpOpen && <AddCreditsModal onClose={() => setIsTopUpOpen(false)} />}
      {isWhatsappModal && (
        <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl mx-4 rounded-lg w-full max-w-2xl">
            <div className="p-6">
              <h2 className="mb-4 font-bold text-gray-800 text-2xl">WhatsApp Integration Setup</h2>
              <p className="mb-6 text-gray-600">Follow these steps to integrate WhatsApp with KODI:</p>

              <div className="space-y-4 mb-6">
                <div className="flex items-start">
                  <div className="flex items-center h-6">
                    <span className="flex justify-center items-center bg-blue-100 mr-3 p-3 rounded-full w-6 h-6 text-blue-800">1</span>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">Create a Facebook Business Account</p>
                    <p className="text-gray-600 text-xs">
                      Go to <a href="https://business.facebook.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">business.facebook.com</a> and set up your business account if you don't have one.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex items-center h-6">
                    <span className="flex justify-center items-center bg-blue-100 mr-3 p-3 rounded-full w-6 h-6 text-blue-800">2</span>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">Use a Dedicated WhatsApp Number</p>
                    <p className="text-gray-600 text-xs">
                      Ensure the phone number you use is <strong>dedicated for WhatsApp Business only</strong>. It should not be tied to a personal or existing WhatsApp account. If already in use, unregister it first.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex items-center h-6">
                    <span className="flex justify-center items-center bg-blue-100 mr-3 p-3 rounded-full w-6 h-6 text-blue-800">3</span>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">Set Up WhatsApp Business Account</p>
                    <p className="text-gray-600 text-xs">Download WhatsApp Business app and register your business phone number.</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex items-center h-6">
                    <span className="flex justify-center items-center bg-blue-100 mr-3 p-3 rounded-full w-6 h-6 text-blue-800">4</span>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">Connect to Facebook Business Manager</p>
                    <p className="text-gray-600 text-xs">In your Facebook Business Manager, navigate to Business Settings &gt; Accounts &gt; WhatsApp Accounts.</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex items-center h-6">
                    <span className="flex justify-center items-center bg-blue-100 mr-3 p-3 rounded-full w-6 h-6 text-blue-800">5</span>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">Get API Credentials</p>
                    <p className="text-gray-600 text-xs">You'll need your WhatsApp Business Account ID and Phone Number ID.</p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 mb-6 p-4 rounded-md">
                <h3 className="font-medium text-blue-800 text-sm">Important Note</h3>
                <p className="mt-2 text-blue-700 text-sm">
                  Make sure you have admin access to the Facebook Business Manager and the WhatsApp Business account you're trying to connect.
                </p>
              </div>

              <div className="flex justify-end gap-3">
                <button
                  className="hover:bg-gray-50 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                  onClick={() => setWhatsupModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 text-white"
                  onClick={() => {
                    // Add your confirmation action here
                    setWhatsupModal(false);
                  }}
                >
                  I Understand
                </button>
              </div>
            </div>
          </div>
        </div>

      )}
    </div>

  )


}